import { DateInputSplit, SegmentedControl, typographyRem } from '@by-miles/bymiles-styles'

import { DateErrorState, DateState } from '../../../../utils/dateTypes'
import { validationRules } from './utils/validationRules'
const { h5: H5, paragraphBody: ParagraphBody } = typographyRem

interface ConfirmPurchaseDateProps {
  showErrorBanner: boolean
  notAnsweredMessage: string
  preExistingConfirmPurchaseDate?: boolean
  purchaseDate: string
  confirmPurchaseDate?: boolean | null
  handleConfirmPurchaseDate: (value: boolean) => void
  customPurchaseDate: DateState
  setCustomPurchaseDate: (value: DateState) => void
  customPurchaseDateValid: boolean
  customDateError: string
  setCustomDateError: (value: string) => void
  setDateError: (value: boolean) => void
  handleCheckDate: () => void
  handleCustomPurchaseDateErrors: (value: DateErrorState) => void
  manufactureDate?: string
}

export const PurchaseDate = ({
  showErrorBanner,
  notAnsweredMessage,
  preExistingConfirmPurchaseDate,
  purchaseDate,
  confirmPurchaseDate,
  handleConfirmPurchaseDate,
  customPurchaseDate,
  setCustomPurchaseDate,
  customPurchaseDateValid,
  customDateError,
  setCustomDateError,
  setDateError,
  handleCheckDate,
  handleCustomPurchaseDateErrors,
  manufactureDate,
}: ConfirmPurchaseDateProps) => {
  return (
    <>
      {preExistingConfirmPurchaseDate !== false && (
        <div className="question-container" id="confirmPurchaseDate">
          <div className="question-text-container">
            <H5>Did you buy your car in {purchaseDate}?</H5>
            <ParagraphBody className="question-info">This is based on data from the DVLA.</ParagraphBody>
          </div>
          <div className="input-info-container">
            <SegmentedControl
              options={[
                { label: 'yes', value: true },
                { label: 'no', value: false },
              ]}
              name="purchase-date"
              preFilledValue={confirmPurchaseDate}
              onClick={value => typeof value === 'boolean' && handleConfirmPurchaseDate(value)}
              dataCy="purchase-date-toggle"
              error={showErrorBanner && confirmPurchaseDate === null ? notAnsweredMessage : ''}
              ariaLiveOnFocus
            />
          </div>
        </div>
      )}

      {confirmPurchaseDate === false && (
        <div className="question-container" id="customPurchaseDate">
          <div className="question-text-container">
            <H5>When did you (or will you) buy the car?</H5>
          </div>
          <DateInputSplit
            dataCy="purchase-date-text-field"
            showLabels={true}
            validateOnBlur={false}
            toggleErrorMessage={!!customDateError || (showErrorBanner && !customPurchaseDateValid)}
            dateStructure={['month', 'year']}
            onBlur={() => handleCheckDate()}
            onError={handleCustomPurchaseDateErrors}
            errorMessage={
              customDateError || (showErrorBanner && !customPurchaseDateValid ? notAnsweredMessage : undefined)
            }
            onChange={(value: number, field: string) => {
              setCustomDateError('')
              setDateError(false)
              setCustomPurchaseDate({
                ...customPurchaseDate,
                [field]: value,
              })
            }}
            customValidation={validationRules(manufactureDate || '')}
            defaultValue={customPurchaseDate}
            ariaLiveOnFocus
          />
        </div>
      )}
    </>
  )
}
